AFRAME.registerComponent('stock-bar', {
    schema: {
        stockData: { type: 'string', default: '' },
        baseColor: { type: 'string', default: '#fff200' }
    },
    init: function () {
        const el = this.el;
        el.setAttribute('data-raycastable', '');
        this.popup = null;
        this.fullPopup = null;
        this.polygonApiManager = null;
        this.enrichedStock = null;
        this.isCurrentlyHovered = false;
        this.rotationActive = false;
        this.wasJustRotating = false;
        this.rotationController = null;
        this.startMouse = { x: 0, y: 0 };
        this.currentMouse = { x: 0, y: 0 };
        this.initialWrapperRotation = null;
        this.initialWrapperQuaternion = new THREE.Quaternion();
        this.initialControllerQuaternion = new THREE.Quaternion();
        this.isRotationLocked = false;
        this.rotationLockAxis = null;
        this.dragStartX = 0;
        this.dragStartY = 0;
        this.LOCK_THRESHOLD = 5;
        this.raycastEl = null;

        this.onWindowMouseMove = this.onWindowMouseMove.bind(this);
        this.onWindowMouseUp = this.onWindowMouseUp.bind(this);
        this.onWindowTouchMove = this.onWindowTouchMove.bind(this);
        this.onWindowTouchStart = this.onWindowTouchStart.bind(this);
        this.onWindowTouchEnd = this.onWindowTouchEnd.bind(this);
        // Add listeners immediately
        if (typeof window !== 'undefined') {
            window.addEventListener('mousemove', this.onWindowMouseMove);
            window.addEventListener('mouseup', this.onWindowMouseUp);
            window.addEventListener('touchstart', this.onWindowTouchStart, { passive: true });
            window.addEventListener('touchmove', this.onWindowTouchMove, { passive: false });
            window.addEventListener('touchend', this.onWindowTouchEnd);
            window.addEventListener('touchcancel', this.onWindowTouchEnd);
        }
        this.el.addEventListener('raycaster-intersected', e => {
            if (!this.rotationActive) {
                this.raycastEl = e.detail.el;
            }
        });
        this.el.addEventListener('raycaster-intersected-cleared', e => {
            if (!this.rotationActive) {
                this.raycastEl = null;
            }
        });

        // Mouse Down
        this.el.addEventListener('mousedown', (e) => {
            this.startRotation(e);
        });

        // --- ROTATION LOGIC END ---

        this.initializePolygonApi();

        this.themeMode = 'Dark';
        try {
            const mainSettings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
            if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
                this.themeMode = mainSettings.themeMode;
            }
        } catch (e) {
        }
        this._getCurrentThemeMode = () => {
            try {
                const settings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
                if (settings && (settings.themeMode === 'Light' || settings.themeMode === 'Dark')) {
                    return settings.themeMode;
                }
            } catch (e) {
            }
            return this.themeMode || 'Dark';
        };
        this._getThemeColors = () => {
            const currentTheme = this._getCurrentThemeMode();
            const isLight = currentTheme === 'Light';
            return {
                isLight,
                bgColor: isLight ? '#FFFFFF' : '#222',
                textColor: isLight ? '#000000' : '#FFFFFF',
                labelColor: isLight ? '#000000' : '#FFFFFF',
                labelOpacity: isLight ? '1' : '0.5'
            };
        };
        this.refreshPopupTheme = () => {
            const { bgColor, textColor, labelColor, labelOpacity } = this._getThemeColors();
            const small = document.getElementById('stock-popup');
            if (small) {
                small.setAttribute('color', bgColor);
                small.querySelectorAll('a-text').forEach((t) => {
                    const align = t.getAttribute('align');
                    if (align === 'right') {
                        t.setAttribute('color', labelColor);
                        t.setAttribute('opacity', labelOpacity);
                    } else {
                        t.setAttribute('color', textColor);
                    }
                });
            }
            const full = document.getElementById('stock-popup-full');
            if (full) {
                full.setAttribute('color', bgColor);
                full.querySelectorAll('a-text').forEach((t) => {
                    const align = t.getAttribute('align');
                    if (align === 'right') {
                        t.setAttribute('color', labelColor);
                        t.setAttribute('opacity', labelOpacity);
                    } else {
                        t.setAttribute('color', textColor);
                    }
                });
            }
        };
        this._onThemeChanged = (e) => {
            const themeMode = e && e.detail && e.detail.themeMode ? e.detail.themeMode : null;
            if (!themeMode) return;
            this.themeMode = themeMode;
            this.refreshPopupTheme();
        };
        const scene = this.el.sceneEl || document.querySelector('a-scene');
        if (scene && typeof scene.addEventListener === 'function') {
            scene.addEventListener('theme-changed', this._onThemeChanged);
        }
        document.addEventListener('theme-changed', this._onThemeChanged);
        window.addEventListener('theme-changed', this._onThemeChanged);

        this.defaultOpacity = undefined;

        el.addEventListener('mouseenter', async (event) => {
            this.isCurrentlyHovered = true;
            if (this.checkIfChartNotBlocked()) return;
            await this.handleMouseEnter(event);
        });
        el.addEventListener('mouseleave', () => {
            this.isCurrentlyHovered = false;
            this.handleMouseLeave();
        });
        el.addEventListener('click', () => {
            if (this.checkIfChartNotBlocked()) return
            const stock = this.enrichedStock || this.getResolvedStockData();
            this.showFullPopup(stock);
            this.openStockChart(stock);

            if (window.VRPanelsSlidingManager) {
                const isSelected = window.VRPanelsSlidingManager.selectedEl === this.el;
                const nextSelected = isSelected ? null : this.el;
                window.VRPanelsSlidingManager.setSelectedEl(nextSelected);
                window.VRPanelsSlidingManager.dimOtherStockBars(nextSelected);
            }

            if (typeof window.updateRightAverageVolumeGaugeFromStock === 'function') {
                window.updateRightAverageVolumeGaugeFromStock(stock);
            }

            const scene = this.el.sceneEl || document.querySelector('a-scene');
            if (scene) {
                scene.emit('stock-selected', stock);
            }
        });
    },
    getResolvedStockData: function () {
        const fallback = {
            ticker: 'UNKNOWN',
            todaysChangePerc: 0,
            price: 0,
            volume: 0,
            tickerSummary: {
                name: 'UNKNOWN',
                primary_exchange: 'Unknown Exchange',
                market_cap: 0,
                previous_close: 0
            }
        };
        if (this.el && this.el.__stockData) {
            return this.el.__stockData;
        }
        const stockDataAttr = this.el && this.el.getAttribute ? this.el.getAttribute('stock-bar') : null;
        if (stockDataAttr && stockDataAttr.stockData) {
            try {
                const parsedAttr = JSON.parse(stockDataAttr.stockData);
                this.el.__stockData = parsedAttr;
                return parsedAttr;
            } catch (error) {
                console.error('[stock-bar] Failed to parse stockData from stock-bar attribute:', error);
            }
        }
        try {
            if (this.data.stockData) {
                const parsed = JSON.parse(this.data.stockData);
                this.el.__stockData = parsed;
                return parsed;
            }
        } catch (error) {
            console.error('[stock-bar] Failed to parse stockData from schema data:', error);
        }
        return fallback;
    },
    checkIfChartNotBlocked() {
        const centerPanelContent = document.getElementById('large-center-panel-content');
        if (centerPanelContent && centerPanelContent.getAttribute('visible') === false) {
            return true;
        }
        const centerPanel = document.getElementById('large-center-panel');
        if (centerPanel && centerPanel.getAttribute('visible') === false) {
            return true;
        }
        const configureControlElement = document.querySelector('#configure-control');
        const configureControlAttr = configureControlElement ? configureControlElement.getAttribute('configure-control') : null;
        return !!(configureControlAttr && configureControlAttr.position === 'Manual')
    },
    async initializePolygonApi() {
        try {
            this.polygonApiManager = await PolygonAPIManager.create();
        } catch (error) {
            console.error('Failed to initialize PolygonAPIManager:', error.message);
        }
    },
    async fetchTickerDetails(stock) {
        stock.tickerSummary = stock.tickerSummary || {
            name: stock.ticker || 'UNKNOWN',
            primary_exchange: 'Unknown Exchange',
            market_cap: 0,
            previous_close: 0
        };
        console.debug(`Original tickerSummary for ${stock.ticker}:`, stock.tickerSummary);
        if (stock.tickerDetails && typeof stock.tickerDetails === 'object') {
            console.debug(`Using existing tickerDetails for ${stock.ticker} from stock object`);
            this.enrichedStock = { ...stock };
            return;
        }
        if (!this.polygonApiManager) {
            console.warn('PolygonAPIManager not initialized, skipping ticker details fetch');
            this.enrichedStock = { ...stock };
            return;
        }
        const cacheKey = `ticker_${stock.ticker || 'UNKNOWN'}`;
        let tickerDetails = null;
        let cachedStock = null;
        cachedStock = getCacheItem(cacheKey);
        console.debug(`Cached stock data for ${cacheKey}:`, cachedStock);
        if (cachedStock && cachedStock.tickerDetails && typeof cachedStock.tickerDetails === 'object') {
            tickerDetails = cachedStock.tickerDetails;
            stock = { ...cachedStock, ...stock };
        } else {
            console.debug(`No valid tickerDetails in cache for ${stock.ticker} (cachedStock: ${JSON.stringify(cachedStock)}), fetching from API`);
        }
        if (!tickerDetails) {
            try {
                const enriched = await this.polygonApiManager.enrichWithTickerDetails([stock], 10);
                console.debug(`PolygonAPIManager enriched data for ${stock.ticker}:`, enriched);
                tickerDetails = enriched[0]?.tickerDetails || {
                    name: stock.tickerSummary.name || stock.ticker || 'UNKNOWN',
                    primary_exchange: stock.tickerSummary.primary_exchange || 'Unknown Exchange',
                    market_cap: stock.tickerSummary.market_cap || 0,
                    previous_close: stock.tickerSummary.previous_close || 0,
                    list_date: 'N/A'
                };
                if (stock.tickerSummary.name === stock.ticker || stock.tickerSummary.primary_exchange === 'Unknown Exchange') {
                    stock.tickerSummary = {
                        name: tickerDetails.name,
                        primary_exchange: tickerDetails.primary_exchange,
                        market_cap: tickerDetails.market_cap || stock.tickerSummary.market_cap,
                        previous_close: tickerDetails.previous_close || stock.tickerSummary.previous_close
                    };
                    console.debug(`Updated tickerSummary for ${stock.ticker}:`, stock.tickerSummary);
                }
                const updatedStock = {
                    ...cachedStock,
                    ...stock,
                    tickerSummary: { ...stock.tickerSummary },
                    tickerDetails
                };

                try {
                    setCacheItem(cacheKey, updatedStock, 1440);
                } catch (error) {
                    console.error(`❌ Failed to cache stock data for ${stock.ticker}:`, error.message);
                }
            } catch (error) {
                console.error(`❌ Error fetching tickerDetails for ${stock.ticker}:`, error.message);
                tickerDetails = {
                    name: stock.tickerSummary.name || stock.ticker || 'UNKNOWN',
                    primary_exchange: stock.tickerSummary.primary_exchange || 'Unknown Exchange',
                    market_cap: stock.tickerSummary.market_cap || 0,
                    previous_close: stock.tickerSummary.previous_close || 0,
                    list_date: 'N/A'
                };
                if (stock.tickerSummary.name === stock.ticker || stock.tickerSummary.primary_exchange === 'Unknown Exchange') {
                    stock.tickerSummary = {
                        name: tickerDetails.name,
                        primary_exchange: tickerDetails.primary_exchange,
                        market_cap: tickerDetails.market_cap || stock.tickerSummary.market_cap,
                        previous_close: tickerDetails.previous_close || stock.tickerSummary.previous_close
                    };
                    console.debug(`Updated tickerSummary for ${stock.ticker} (fallback):`, stock.tickerSummary);
                }
                const updatedStock = {
                    ...cachedStock,
                    ...stock,
                    tickerSummary: { ...stock.tickerSummary },
                    tickerDetails
                };
                try {
                    setCacheItem(cacheKey, updatedStock, 1440);
                } catch (cacheError) {
                    console.error(`❌ Failed to cache fallback stock data for ${stock.ticker}:`, cacheError.message);
                }
            }
        }
        this.enrichedStock = {
            ...stock,
            tickerSummary: { ...stock.tickerSummary },
            tickerDetails
        };
        console.debug('Enriched stock after update:', this.enrichedStock);
    },
    handleMouseEnter: async function (event) {
        const fullscreenPopup = document.getElementById('fullscreen-popup');
        if (fullscreenPopup) {
            return;
        }
        if (this.el.classList && this.el.classList.contains('drop-in-progress')) {
            return;
        }
        const stock = this.getResolvedStockData();
        await this.handleSimpleMode(stock);
    },
    getDataSource: function () {
        const stockCubeVisualizerEl = document.querySelector('#stock-3d-cube') || document.querySelector('[stock-cube-visualizer]');
        const stockCubeVisualizer = stockCubeVisualizerEl && stockCubeVisualizerEl.components
            ? stockCubeVisualizerEl.components['stock-cube-visualizer']
            : null;
        return stockCubeVisualizer ? stockCubeVisualizer.data?.dataSource : null;
    },
    handleSimpleMode: async function (stock) {
        let isDimmed = false;
        if (window.VRPanelsSlidingManager && window.VRPanelsSlidingManager.selectedEl) {
            isDimmed = (window.VRPanelsSlidingManager.selectedEl !== this.el);
        }
        
        if (!isDimmed) {
            const currentOpacity = this.el.getAttribute('material') ? parseFloat(this.el.getAttribute('material').opacity) : 1;
            if (this.defaultOpacity == null && !isNaN(currentOpacity)) {
                this.defaultOpacity = currentOpacity;
            }
            const baseOpacity = this.defaultOpacity != null ? this.defaultOpacity : 1;
            const hoverOpacity = Math.min(1, baseOpacity + 0.1);
            this.el.setAttribute('material', 'opacity', hoverOpacity);
        }
        
        this.removeFullPopupWhenPopupChanges();
        await this.fetchTickerDetails(stock);
        if (!this.isCurrentlyHovered) return;
        this.showPopupV3(this.enrichedStock || stock);
    },
    handleMouseLeave: function () {
        if (this.el.classList && this.el.classList.contains('drop-in-progress')) {
            return;
        }
        
        let isDimmed = false;
        if (window.VRPanelsSlidingManager && window.VRPanelsSlidingManager.selectedEl) {
            isDimmed = (window.VRPanelsSlidingManager.selectedEl !== this.el);
        }

        if (!isDimmed && this.defaultOpacity != null) {
            this.el.setAttribute('material', 'opacity', this.defaultOpacity);
        }
        
        if (this.popup) {
            this.popup.remove();
            this.popup = null;
        }
        this.removeFullPopupIfNotAttached();
    },
    removeFullPopupWhenPopupChanges: function () {
        let allFullPopups = [];
        const byQuerySelector = document.querySelectorAll('#stock-popup-full');
        allFullPopups = Array.from(byQuerySelector);
        const byId = document.getElementById('stock-popup-full');
        if (byId && !allFullPopups.includes(byId)) {
            allFullPopups.push(byId);
        }
        const centerPanelContent = document.getElementById('large-center-panel-content');
        if (centerPanelContent) {
            const inPanel = centerPanelContent.querySelector('#stock-popup-full');
            if (inPanel && !allFullPopups.includes(inPanel)) {
                allFullPopups.push(inPanel);
            }
        }
        if (allFullPopups.length === 0) {
            return;
        }
        allFullPopups.forEach((popup) => {
            if (!popup || !popup.parentNode) {
                return;
            }
            const parent = popup.parentNode;
            if (parent) {
                parent.removeChild(popup);
            }
        });
        this.cleanupFullPopupReferences();
    },
    removeFullPopupIfNotAttached: function () {
        const allFullPopups = document.querySelectorAll('#stock-popup-full');
        if (allFullPopups.length === 0) {
            return;
        }
        allFullPopups.forEach((popup) => {
            if (!popup || !popup.parentNode) {
                return;
            }
            popup.parentNode.removeChild(popup);
        });
        this.cleanupFullPopupReferences();
    },
    cleanupFullPopupReferences: function () {
        const allStockBars = document.querySelectorAll('[stock-bar]');
        allStockBars.forEach(barEl => {
            if (barEl.components && barEl.components['stock-bar']) {
                const stockBarComponent = barEl.components['stock-bar'];
                if (stockBarComponent.fullPopup) {
                    if (!stockBarComponent.fullPopup.parentNode ||
                        !document.body.contains(stockBarComponent.fullPopup)) {
                        stockBarComponent.fullPopup = null;
                    }
                }
            }
        });
        if (this.fullPopup) {
            if (!this.fullPopup.parentNode || !document.body.contains(this.fullPopup)) {
                this.fullPopup = null;
            }
        }
    },
    formatLargeNumber: function (num) {
        if (!Number.isFinite(num)) return '0';
        const absNum = Math.abs(num);
        if (absNum >= 1.0e+12) return (num / 1.0e+12).toFixed(1) + ' T';
        if (absNum >= 1.0e+9) return (num / 1.0e+9).toFixed(1) + ' B';
        if (absNum >= 1.0e+6) return (num / 1.0e+6).toFixed(1) + ' M';
        if (absNum >= 1.0e+3) return (num / 1.0e+3).toFixed(1) + ' K';
        return num.toFixed(2);
    },
    formatNumberWithCommas: function (num) {
        if (num === null || num === undefined || isNaN(num)) return '0';
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    formatPriceWithCommas: function (price) {
        if (price === null || price === undefined || isNaN(price)) return '0.00';
        const fixed = parseFloat(price).toFixed(2);
        const parts = fixed.split('.');
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    },
    updatePopupV3: function (stock, existingPopup) {
        this.removeFullPopupWhenPopupChanges();
        let currentTheme = { bgColor: '#222', textColor: 'white', labelColor: '#FFFFFF', labelOpacity: '0.5' };
        if (this._getThemeColors) {
            currentTheme = this._getThemeColors();
            const { bgColor, textColor, labelColor, labelOpacity } = currentTheme;
            existingPopup.setAttribute('color', bgColor);
            existingPopup.querySelectorAll('a-text').forEach((t) => {
                const align = t.getAttribute('align');
                if (align === 'right') {
                    t.setAttribute('color', labelColor);
                    t.setAttribute('opacity', labelOpacity);
                } else {
                    t.setAttribute('color', textColor);
                }
            });
        }
        const isTrueVRMode = window.AppState && window.AppState.isTrueVRMode;
        existingPopup.setAttribute('rotation', '0 0 0');
        if (isTrueVRMode) {
            existingPopup.setAttribute('rotation', '0 45 0');
        }
        const price = stock.day && stock.day.c ? stock.day.c : stock.price || 0;
        const values = existingPopup.querySelector('a-text[align="left"]');
        const labels = existingPopup.querySelector('a-text[align="right"]');
        const allTexts = existingPopup.querySelectorAll('a-text');
        let companynameEl = null;
        allTexts.forEach(el => {
            const align = el.getAttribute('align');
            const width = el.getAttribute('width');
            if (align === 'left' && parseFloat(width) > 2.0) {
                companynameEl = el;
            }
        });
        const { extraLabels, extraValues, extraRowsCount } = this.getExtraFields(stock);
        if (values) {
            const exchangeValue = stock.tickerDetails?.primary_exchange ||
                stock.tickerSummary?.primary_exchange ||
                stock.primary_exchange ||
                'Unknown Exchange';
            values.setAttribute('value',
                `${stock.ticker || 'UNKNOWN'}\n` +
                `${exchangeValue}\n` +
                `${(stock.todaysChangePerc || 0).toFixed(1)}%\n` +
                `$${this.formatPriceWithCommas(price)}\n` +
                extraValues
            );
        }
        if (labels) {
            labels.setAttribute('value',
                `Ticker:\n` +
                `Exchange:\n` +
                `Change:\n` +
                `Price:\n` +
                extraLabels
            );
        }
        if (companynameEl) {
            let cName = stock.tickerDetails?.name || stock.tickerSummary?.name || stock.ticker || 'UNKNOWN';
            if (cName.length > 20) {
                cName = cName.substring(0, 20) + '...';
            }
            companynameEl.setAttribute('value', `${cName}\n`);
        }
        if (values && labels && companynameEl) {
            this.adjustForExtraFields(existingPopup, extraRowsCount, labels, values, companynameEl);
        }
    },
    showPopupV3: function (stock) {
        this.removeFullPopupWhenPopupChanges();
        
        const existingPopups = document.querySelectorAll('#stock-popup');
        existingPopups.forEach(p => {
            if (p.parentNode) {
                p.parentNode.removeChild(p);
            }
        });

        const popup = this.createPopupElement(stock);
        this.addTextElements(popup, stock);
        this.attachToDOM(popup);
        this.setupPositioning(popup);
        this.popup = popup;
    },
    createPopupElement: function (stock) {
        const popup = document.createElement('a-rounded-plane');
        popup.setAttribute('id', 'stock-popup');
        popup.setAttribute('scale', '0.4 0.4 0.4');
        popup.setAttribute('width', '1.5');
        popup.setAttribute('height', '0.52');
        popup.setAttribute('radius', '0.05');
        const { bgColor } = this._getThemeColors ? this._getThemeColors() : { bgColor: '#222' };
        popup.setAttribute('color', bgColor);
        return popup;
    },
    getExtraFields: function (stock) {
        const chartTypeValue = this.getDataSource();
        let extraLabels = '';
        let extraValues = '';
        let extraRowsCount = 0;
        const price = stock.day && stock.day.c ? stock.day.c : stock.price || 0;
        if (['dividend', 'dividend-sec'].includes(chartTypeValue)) {
            const yieldPct = stock.trail_1y_div_yield_pct || 0;
            const divAmount = stock.trail_1y_div;
            extraLabels = `Dividend (Yield):\n`;
            extraValues = `$${divAmount.toFixed(2)} (${yieldPct.toFixed(1)}%)\n`;
            extraRowsCount = 1;
        } else if (['sip', 'sip-sec'].includes(chartTypeValue)) {
            extraLabels = `Short Interest:\n`;
            extraValues = `${(stock.short_interest_pct || 0).toFixed(1)}%\n`;
            extraRowsCount = 1;
        } else if (['top-dollar-vol', 'top-dollar-vol-sec'].includes(chartTypeValue)) {
            const volume = stock.day && stock.day.v ? stock.day.v : stock.volume || 0;
            const dollarVol = (stock.cumulative_dollar_volume || stock.dollarVolume)
                ? (stock.cumulative_dollar_volume || stock.dollarVolume)
                : (price * volume);
            extraLabels = `Dollar Vol.:\n`;
            extraValues = `$${this.formatLargeNumber(dollarVol)}\n`;
            extraRowsCount = 1;
        } else if (['top-vol', 'top-vol-sec'].includes(chartTypeValue)) {
            const displayVol = stock.cumulative_volume || (stock.day && stock.day.v ? stock.day.v : stock.volume) || 0;
            extraLabels = `Volume:\n`;
            extraValues = `${this.formatLargeNumber(displayVol)}\n`;
            extraRowsCount = 1;
        }
        return { extraLabels, extraValues, extraRowsCount };
    },
    createLabelsElement: function (extraLabels) {
        const { labelColor, labelOpacity } = this._getThemeColors ? this._getThemeColors() : { labelColor: '#FFFFFF', labelOpacity: '0.5' };
        const labels = document.createElement('a-text');
        labels.setAttribute('value',
            `Ticker:\n` +
            `Exchange:\n` +
            `Change:\n` +
            `Price:\n` +
            extraLabels
        );
        labels.setAttribute('position', '0.5 0.37 0.02');
        labels.setAttribute('align', 'right');
        labels.setAttribute('baseline', 'top');
        labels.setAttribute('color', labelColor);
        labels.setAttribute('opacity', labelOpacity);
        labels.setAttribute('scale', '0.7 0.7 0.7');
        labels.setAttribute('width', '2.1');
        labels.setAttribute('shader', 'msdf');
        labels.setAttribute('font', 'roboto');
        labels.setAttribute('negate', 'true');
        labels.setAttribute('alphaTest', '0.5');
        return labels;
    },
    createValuesElement: function (stock, extraValues) {
        const { textColor } = this._getThemeColors ? this._getThemeColors() : { textColor: 'white' };
        const price = stock.day && stock.day.c ? stock.day.c : stock.price || 0;
        let exchangeValue = 'Unknown Exchange';
        if (stock.tickerDetails?.primary_exchange && stock.tickerDetails.primary_exchange !== 'Unknown Exchange') {
            exchangeValue = stock.tickerDetails.primary_exchange;
        } else if (stock.tickerSummary?.primary_exchange && stock.tickerSummary.primary_exchange !== 'Unknown Exchange') {
            exchangeValue = stock.tickerSummary.primary_exchange;
        } else if (stock.primary_exchange && stock.primary_exchange !== 'Unknown Exchange') {
            exchangeValue = stock.primary_exchange;
        }
        const values = document.createElement('a-text');
        values.setAttribute('value',
            `${stock.ticker || 'UNKNOWN'}\n` +
            `${exchangeValue}\n` +
            `${(stock.todaysChangePerc || 0).toFixed(1)}%\n` +
            `$${this.formatPriceWithCommas(price)}\n` +
            extraValues
        );
        values.setAttribute('position', '0.6 0.37 0.02');
        values.setAttribute('align', 'left');
        values.setAttribute('baseline', 'top');
        values.setAttribute('color', textColor);
        values.setAttribute('scale', '0.7 0.7 0.7');
        values.setAttribute('width', '2.1');
        values.setAttribute('shader', 'msdf');
        values.setAttribute('font', 'roboto');
        values.setAttribute('negate', 'true');
        values.setAttribute('alphaTest', '0.5');
        return values;
    },
    createCompanyNameElement: function (stock) {
        const { textColor } = this._getThemeColors ? this._getThemeColors() : { textColor: 'white' };
        const companyname = document.createElement('a-text');
        let cName = stock.tickerDetails?.name || stock.tickerSummary?.name || stock.ticker || 'UNKNOWN';
        if (cName.length > 20) {
            cName = cName.substring(0, 20) + '...';
        }
        companyname.setAttribute('value', `${cName}\n`);
        companyname.setAttribute('position', '0.35 0.45 0.01');
        companyname.setAttribute('align', 'left');
        companyname.setAttribute('color', textColor);
        companyname.setAttribute('scale', '0.7 0.7 0.7');
        companyname.setAttribute('width', 2.3);
        companyname.setAttribute('shader', 'msdf');
        companyname.setAttribute('font', 'roboto');
        companyname.setAttribute('negate', 'true');
        companyname.setAttribute('alphaTest', '0.5');
        return companyname;
    },
    createActionElement: function () {
        const action = document.createElement('a-text');
        action.setAttribute('value', 'Click bar to open stock chart');
        action.setAttribute('position', '0.6 0.05 0.01');
        action.setAttribute('align', 'center');
        action.setAttribute('color', '#6C6CFF');
        action.setAttribute('scale', '0.6 0.65 0.6');
        action.setAttribute('width', '2');
        action.setAttribute('shader', 'msdf');
        action.setAttribute('font', 'roboto');
        action.setAttribute('negate', 'true');
        action.setAttribute('alphaTest', '0.5');
        return action;
    },
    addTextElements: function (popup, stock) {
        const { extraLabels, extraValues, extraRowsCount } =
            this.getExtraFields(stock);
        const labels = this.createLabelsElement(extraLabels);
        popup.appendChild(labels);
        const values = this.createValuesElement(stock, extraValues);
        popup.appendChild(values);
        const companyname = this.createCompanyNameElement(stock);
        popup.appendChild(companyname);
        const action = this.createActionElement();
        popup.appendChild(action);
        if (extraRowsCount > 0) {
            this.adjustForExtraFields(popup, extraRowsCount, labels, values, companyname);
        }
    },
    adjustForExtraFields: function (popup, extraRowsCount, labels, values, companyname) {
        const baseHeight = 0.52;
        const newHeight = baseHeight + (extraRowsCount * 0.07);
        popup.setAttribute('height', newHeight.toString());
        const baseY = 0.380;
        const newY = baseY - (extraRowsCount * 0.035);
        popup.setAttribute('position', `-0.110 ${newY} 0.130`);
        popup.setAttribute('height', newHeight.toString());
        const companyY = 0.45 + (extraRowsCount * 0.035);
        const deltaH = extraRowsCount * 0.07;
        const shift = deltaH / 2;
        const companyBaseY = 0.45;
        const labelsBaseY = 0.37;
        companyname.setAttribute('position', `0.35 ${companyBaseY + shift} 0.01`);
        labels.setAttribute('position', `0.5 ${labelsBaseY + shift} 0.02`);
        values.setAttribute('position', `0.6 ${labelsBaseY + shift} 0.02`);
    },
    attachToDOM: function (popup) {
        const centerPanelContent = document.getElementById("large-center-panel-content");
        if (centerPanelContent) {
            if (!popup.parentElement) {
                const worldPos = new AFRAME.THREE.Vector3();
                this.el.object3D.getWorldPosition(worldPos);
                this.el.sceneEl.appendChild(popup);
                popup.setAttribute('height', '0.52');
                popup.setAttribute('position', `${worldPos.x} ${worldPos.y + 0.15} ${worldPos.z + 0.1}`);
                popup.setAttribute('rotation', '0 0 0');
            } else {
            }
        } else {
            if (!popup.parentElement) {
                this.el.appendChild(popup);
                popup.setAttribute('position', '0.15 2 0.6');
            }
        }
    },
    setupPositioning: function (popup) {
        popup.setAttribute('rotation', '0 45 0');
        popup.setAttribute('scale', '0.4 0.4 0.4');
        const worldPos = new AFRAME.THREE.Vector3();
        this.el.object3D.getWorldPosition(worldPos);
        const cameraEl = document.querySelector('[camera]');
        const cameraPos = new AFRAME.THREE.Vector3();
        if (cameraEl) cameraEl.object3D.getWorldPosition(cameraPos);
        else cameraPos.set(0, 1.6, 0);
        const dir = new AFRAME.THREE.Vector3().subVectors(cameraPos, worldPos).normalize();
        const push = 0.5;
        const sceneWrapper = document.querySelector('#scene-wrapper');
        let minZPos = -0.5;
        if (sceneWrapper && sceneWrapper.object3D && sceneWrapper.object3D.position) {
            minZPos += sceneWrapper.object3D.position.z || 0;
        }
        const posX = worldPos.x + dir.x * push + 0.05;
        const posY = worldPos.y + dir.y * push + 0.05;
        const posZ = Math.min(worldPos.z + dir.z * push * 3, minZPos);
        setTimeout(() => {
            popup.setAttribute('position', `${posX} ${posY} ${posZ}`);
            popup.setAttribute('rotation', '0 0 0');
        }, 0);
        popup.setAttribute('visible', true);
    },
    updateFullPopup: async function (stock, existingPopup) {
        if (this._getThemeColors) {
            const { bgColor, textColor, labelColor, labelOpacity } = this._getThemeColors();
            existingPopup.setAttribute('color', bgColor);
            existingPopup.querySelectorAll('a-text').forEach((t) => {
                const align = t.getAttribute('align');
                if (align === 'right') {
                    t.setAttribute('color', labelColor);
                    t.setAttribute('opacity', labelOpacity);
                } else {
                    t.setAttribute('color', textColor);
                }
            });
        }
        const formatMarketCap = (marketCap) => {
            if (!marketCap) return 'N/A';
            const trillion = 1e12;
            const billion = 1e9;
            const million = 1e6;
            if (marketCap >= trillion) return `$${(marketCap / trillion).toFixed(2)}T`;
            if (marketCap >= billion) return `$${(marketCap / billion).toFixed(2)}B`;
            if (marketCap >= million) return `$${(marketCap / million).toFixed(2)}M`;
            return `$${this.formatNumberWithCommas(marketCap)}`;
        };
        const isWarrantByName = (stock.ticker || '').endsWith('W') && /warrant/i.test(stock.tickerDetails?.name || stock.tickerSummary?.name || '');
        const isDerivative = stock.tickerDetails?.type === 'WARRANT' || stock.tickerDetails?.type === 'OPTION' || isWarrantByName;
        const marketCap = isDerivative && stock.tickerDetails?.underlyingDetails
            ? stock.tickerDetails.underlyingDetails.market_cap
            : (stock.tickerDetails?.market_cap || stock.tickerSummary?.market_cap || 0);
        let range52Week = stock.range52Week ||
            stock.performanceData?.range52Week ||
            stock.tickerDetails?.range52Week ||
            null;
        if (!range52Week && stock.ticker && window.RightPanelProxyAPIManager) {
            try {
                const apiManager = window.RightPanelProxyAPIManager.instance || null;
                if (apiManager && apiManager.isInitialized) {
                    const cachedPerformance = apiManager.getCachedData('performance', stock.ticker);
                    if (cachedPerformance && cachedPerformance.range52Week) {
                        range52Week = cachedPerformance.range52Week;
                    }
                }
            } catch (e) {
                console.debug('Could not get cached performance data from RightPanelProxyAPIManager:', e);
            }
        }
        const high52Week = range52Week?.high ||
            stock.tickerDetails?.high_52_week ||
            stock.tickerDetails?.year_high ||
            stock.tickerDetails?.high ||
            null;
        const low52Week = range52Week?.low ||
            stock.tickerDetails?.low_52_week ||
            stock.tickerDetails?.year_low ||
            stock.tickerDetails?.low ||
            null;
        const high52WeekText = (high52Week != null && high52Week > 0) ? (() => {
            const parts = high52Week.toFixed(2).split('.');
            return `$${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${parts[1]}`;
        })() : 'N/A';
        const low52WeekText = (low52Week != null && low52Week > 0) ? (() => {
            const parts = low52Week.toFixed(2).split('.');
            return `$${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${parts[1]}`;
        })() : 'N/A';
        const price = stock.day?.c || stock.price || 0;
        
        const activeInterval = (typeof getCacheItem === 'function' ? getCacheItem('data-interval') : null) || '1D';
        const intervalLower = activeInterval.toLowerCase();
        let volume;
        if (intervalLower === '1d') {
            volume = stock.cumulative_volume || 0;
        } else if (intervalLower === '5d' || intervalLower === '1m') {
            volume = stock.volume || 0;
        } else {
            volume = stock.cumulative_volume || 0;
        }

        let sipLabels = '';
        let sipValues = '';
        const chartTypeValue = this.getDataSource();
        const isShortInterestChart = ['sip', 'sip-sec', 'dividend', 'dividend-sec'].includes(chartTypeValue);
        const isDividendChart = chartTypeValue === 'dividend' || chartTypeValue === 'dividend-sec';
        let additionalLabels = '';
        let additionalValues = '';
        if (['top-dollar-vol', 'top-dollar-vol-sec'].includes(chartTypeValue)) {
            const volForDollar = (intervalLower === '5d' || intervalLower === '1m') ? (stock.volume || 0) : (stock.cumulative_volume || 0);
            const dollarVol = (stock.cumulative_dollar_volume || stock.dollarVolume)
                ? (stock.cumulative_dollar_volume || stock.dollarVolume)
                : (price * volForDollar);
            additionalLabels += `Dollar Vol.:\n`;
            additionalValues += `$${this.formatLargeNumber(dollarVol)}\n`;
        }
        if (['top-vol', 'top-vol-sec'].includes(chartTypeValue)) {
            const displayVol = (intervalLower === '5d' || intervalLower === '1m') ? (stock.volume || 0) : (stock.cumulative_volume || 0);
            additionalLabels += `Volume:\n`;
            additionalValues += `${this.formatLargeNumber(displayVol)}\n`;
        }
        if (isShortInterestChart) {
            if (isDividendChart) {
                const yieldPct = stock.trail_1y_div_yield_pct || 0;
                const divAmount = stock.trail_1y_div;
                sipLabels = `Dividend Yield:\n Dividend Amount:\n`;
                sipValues =
                    `${yieldPct.toFixed(2)}%\n` +
                    `$${divAmount.toFixed(2)}\n`;
            } else {
                sipLabels = `Short Interest Percent:\n Settlement date:\n`;
                sipValues =
                    `${stock.short_interest_pct || 'N/A'}%\n` +
                    `${stock.settlement_date || 'N/A'}\n`;
            }
        }
        const allTextElements = existingPopup.querySelectorAll('a-text');
        let companyDateEl = existingPopup.querySelector('a-text.stock-company-date');
        let logoEl = existingPopup.querySelector('a-image.stock-company-logo');
        let companynameEl = existingPopup.querySelector('a-text.stock-company-name');
        let labelsEl = null;
        let valuesEl = null;
        allTextElements.forEach(el => {
            const align = el.getAttribute('align');
            const width = el.getAttribute('width');
            if (align === 'right') {
                labelsEl = el;
            } else if (align === 'left' && parseFloat(width) <= 4.0) {
                valuesEl = el;
            }
        });
        if (companyDateEl) {
            companyDateEl.setAttribute('value', this.getDateInFormatAsOf(stock.timestamp));
            companyDateEl.setAttribute('position', isShortInterestChart ? '0.6 0.85 0.001' : '0.6 0.8 0.001');
        }
        let companyLogoUrl = null;
        if (window.CompanyIconAPIManager && stock.ticker) {
            try {
                let apiManager = window.CompanyIconAPIManager.instance;
                if (!apiManager) {
                    apiManager = await window.CompanyIconAPIManager.create();
                }
                companyLogoUrl = await apiManager.loadIcon(stock.ticker);
            } catch (e) {
                console.warn('[stock-bar] Failed to load company icon for updateFullPopup:', e);
            }
        }

        if (companyLogoUrl) {
            if (logoEl) {
                logoEl.setAttribute('src', companyLogoUrl);
                logoEl.setAttribute('position', isShortInterestChart ? '0.43 0.75 0.001' : '0.43 0.65 0.001');
            } else {
                const logo = document.createElement('a-image');
                logo.classList.add('stock-company-logo');
                logo.setAttribute('src', companyLogoUrl);
                logo.setAttribute('width', 0.08);
                logo.setAttribute('height', 0.08);
                logo.setAttribute('transparent', true);
                logo.setAttribute('material', 'alphaTest: 0.1');
                logo.setAttribute('position', isShortInterestChart ? '0.43 0.75 0.001' : '0.43 0.65 0.001');
                if (companynameEl) {
                    existingPopup.insertBefore(logo, companynameEl);
                } else {
                    existingPopup.appendChild(logo);
                }
                logoEl = logo;
            }
        } else {
            if (logoEl) {
                logoEl.remove();
                logoEl = null;
            }
        }
        if (companynameEl) {
            let cName = stock.tickerDetails?.name || stock.tickerSummary?.name || stock.ticker || 'UNKNOWN';
            if (cName.length > 10) {
                cName = cName.substring(0, 10) + '...';
            }
            companynameEl.setAttribute('value', cName);
            const nameXPos = logoEl ? 0.53 : 0.48;
            companynameEl.setAttribute('position', isShortInterestChart ? `${nameXPos} 0.75 0.001` : `${nameXPos} 0.65 0.001`);
            companynameEl.setAttribute('anchor', 'left');
            companynameEl.setAttribute('width', 3.5);
        }
        if (labelsEl) {
            labelsEl.setAttribute('value',
                `Ticker:\n` +
                `Exchange:\n` +
                `Change:\n` +
                `Price:\n` +
                `Volume:\n` +
                additionalLabels +
                sipLabels +
                `Market Cap:\n` +
                `52-Wk High:\n` +
                `52-Wk Low:`
            );
            labelsEl.setAttribute('position', isShortInterestChart ? '0.57 0.35 0.001' : '0.57 0.3 0.001');
        }
        if (valuesEl) {
            valuesEl.setAttribute('value',
                `${stock.ticker || 'UNKNOWN'}\n` +
                `${stock.tickerDetails?.primary_exchange || stock.tickerSummary?.primary_exchange || 'Unknown Exchange'}\n` +
                `${(stock.todaysChangePerc || 0).toFixed(1)}%\n` +
                `$${this.formatPriceWithCommas(price)}\n` +
                `${this.formatNumberWithCommas(volume)}\n` +
                additionalValues +
                sipValues +
                `${formatMarketCap(marketCap)}\n` +
                `${high52WeekText}\n` +
                `${low52WeekText}`
            );
            valuesEl.setAttribute('position', isShortInterestChart ? '0.63 0.35 0.001' : '0.63 0.3 0.001');
        }
        if (isShortInterestChart) {
            existingPopup.setAttribute('height', '1.1');
        } else {
            existingPopup.setAttribute('height', '0.9');
        }
        const sceneEl = this.el.sceneEl || document.querySelector('a-scene');
        if (sceneEl && stock.ticker && valuesEl) {
            const update52WeekData = (event) => {
                if (event.detail && event.detail.ticker === stock.ticker && event.detail.range52Week) {
                    const range52Week = event.detail.range52Week;
                    if (range52Week.high != null && range52Week.low != null && range52Week.high > 0 && range52Week.low > 0) {
                        const highParts = range52Week.high.toFixed(2).split('.');
                        const high52WeekText = `$${highParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${highParts[1]}`;
                        const lowParts = range52Week.low.toFixed(2).split('.');
                        const low52WeekText = `$${lowParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${lowParts[1]}`;
                        const currentValue = valuesEl.getAttribute('value');
                        const currentLabels = labelsEl ? labelsEl.getAttribute('value') : null;
                        if (currentValue) {
                            const lines = currentValue.split('\n');
                            let highIndex = -1;
                            let lowIndex = -1;
                            if (currentLabels) {
                                const labelLines = currentLabels.split('\n');
                                highIndex = labelLines.findIndex(line => line.includes('52-Wk High'));
                                lowIndex = labelLines.findIndex(line => line.includes('52-Wk Low'));
                            }
                            if (highIndex === -1 || lowIndex === -1) {
                                if (isShortInterestChart) {
                                    highIndex = 8;
                                    lowIndex = 9;
                                } else {
                                    highIndex = 6;
                                    lowIndex = 7;
                                }
                            }
                            if (lines[highIndex] !== undefined) lines[highIndex] = high52WeekText;
                            if (lines[lowIndex] !== undefined) lines[lowIndex] = low52WeekText;
                            valuesEl.setAttribute('value', lines.join('\n'));
                        } else {
                            console.warn('[stock-bar] No current value in valuesEl to update');
                        }
                        sceneEl.removeEventListener('performance-data-updated', update52WeekData);
                    } else {
                        console.warn('[stock-bar] range52Week from event has invalid values:', range52Week);
                    }
                } else {
                    console.debug('[stock-bar] Event detail does not match or missing range52Week:', {
                        hasDetail: !!event.detail,
                        eventTicker: event.detail?.ticker,
                        stockTicker: stock.ticker,
                        hasRange52Week: !!event.detail?.range52Week
                    });
                }
            };
            sceneEl.addEventListener('performance-data-updated', update52WeekData);
            setTimeout(() => {
                sceneEl.removeEventListener('performance-data-updated', update52WeekData);
            }, 10000);
        } else {
            console.warn('[stock-bar] Cannot add performance-data-updated listener:', {
                hasSceneEl: !!sceneEl,
                hasTicker: !!stock.ticker,
                hasValuesEl: !!valuesEl
            });
        }
        if (!range52Week && stock.ticker && window.RightPanelProxyAPIManager) {
            try {
                const apiManager = window.RightPanelProxyAPIManager.instance || null;
                if (apiManager && apiManager.isInitialized) {
                    const cachedPerformance = apiManager.getCachedData('performance', stock.ticker);
                    if (cachedPerformance && cachedPerformance.range52Week) {
                        const updatedStock = { ...stock, range52Week: cachedPerformance.range52Week };
                        this.updateFullPopup(updatedStock, existingPopup);
                    } else {
                        apiManager.fetchStockPerformance(stock.ticker).then((performanceData) => {
                            if (performanceData && performanceData.range52Week) {
                                const updatedStock = { ...stock, range52Week: performanceData.range52Week };
                                this.updateFullPopup(updatedStock, existingPopup);
                            } else {
                                console.warn(`⚠️ Performance data fetched but no range52Week for ${stock.ticker}`, performanceData);
                            }
                        }).catch((err) => {
                            console.error('❌ Could not fetch performance data:', err);
                        });
                    }
                } else {
                    console.warn('⚠️ RightPanelProxyAPIManager not initialized or instance not available', {
                        hasManager: !!window.RightPanelProxyAPIManager,
                        hasInstance: !!apiManager,
                        isInitialized: apiManager?.isInitialized
                    });
                }
            } catch (e) {
                console.error('❌ Could not fetch performance data from RightPanelProxyAPIManager:', e);
            }
        } else if (!range52Week) {
            console.warn(`[stock-bar] No range52Week and cannot load:`, {
                hasTicker: !!stock.ticker,
                hasRightPanelProxyAPIManager: !!window.RightPanelProxyAPIManager,
                ticker: stock.ticker
            });
        }
    },
    showFullPopup: async function (stock) {
        const existingFullPopup = document.getElementById('stock-popup-full');
        if (existingFullPopup) {
            if (this.popup && this.popup.parentNode) {
                this.popup.remove();
                this.popup = null;
            }
            if (this.fullPopup && this.fullPopup !== existingFullPopup && this.fullPopup.parentNode) {
                this.fullPopup.remove();
            }
            this.fullPopup = existingFullPopup;
            this.updateFullPopup(stock, existingFullPopup);
            return;
        }
        if (this.fullPopup && !this.fullPopup.parentNode) {
            this.fullPopup = null;
        }
        if (this.popup) {
            if (this.popup.parentNode) {
                this.popup.remove();
            }
            this.popup = null;
        }
        const centerPanelContent = document.getElementById("large-center-panel-content");
        if (!centerPanelContent) return;
        const popup = document.createElement('a-rounded-plane');
        popup.setAttribute('id', 'stock-popup-full');
        popup.setAttribute('scale', '0.4 0.4 0.4');
        popup.setAttribute('width', '1.1');
        popup.setAttribute('height', '0.9');
        popup.setAttribute('radius', '0.05');
        const { bgColor, textColor, labelColor, labelOpacity } = this._getThemeColors ? this._getThemeColors() : { bgColor: '#222', textColor: 'white', labelColor: '#FFFFFF', labelOpacity: '0.5' };
        popup.setAttribute('color', bgColor);
        popup.setAttribute('position', '0.05 0.380 0.130');
        popup.setAttribute('rotation', '0 45 0');
        const formatMarketCap = (marketCap) => {
            if (!marketCap) return 'N/A';
            const trillion = 1e12;
            const billion = 1e9;
            const million = 1e6;
            if (marketCap >= trillion) return `$${(marketCap / trillion).toFixed(2)}T`;
            if (marketCap >= billion) return `$${(marketCap / billion).toFixed(2)}B`;
            if (marketCap >= million) return `$${(marketCap / million).toFixed(2)}M`;
            return `$${this.formatNumberWithCommas(marketCap)}`;
        };
        const isWarrantByName = (stock.ticker || '').endsWith('W') && /warrant/i.test(stock.tickerDetails?.name || stock.tickerSummary?.name || '');
        const isDerivative = stock.tickerDetails?.type === 'WARRANT' || stock.tickerDetails?.type === 'OPTION' || isWarrantByName;
        const marketCap = isDerivative && stock.tickerDetails?.underlyingDetails
            ? stock.tickerDetails.underlyingDetails.market_cap
            : (stock.tickerDetails?.market_cap || stock.tickerSummary?.market_cap || 0);
        let range52Week = stock.range52Week ||
            stock.performanceData?.range52Week ||
            stock.tickerDetails?.range52Week ||
            null;
        if (!range52Week && stock.ticker && window.RightPanelProxyAPIManager) {
            try {
                const apiManager = window.RightPanelProxyAPIManager.instance || null;
                if (apiManager && apiManager.isInitialized) {
                    const cachedPerformance = apiManager.getCachedData('performance', stock.ticker);
                    if (cachedPerformance && cachedPerformance.range52Week) {
                        range52Week = cachedPerformance.range52Week;
                    }
                }
            } catch (e) {
                console.debug('Could not get cached performance data from RightPanelProxyAPIManager:', e);
            }
        }
        const high52Week = range52Week?.high ||
            stock.tickerDetails?.high_52_week ||
            stock.tickerDetails?.year_high ||
            stock.tickerDetails?.high ||
            null;
        const low52Week = range52Week?.low ||
            stock.tickerDetails?.low_52_week ||
            stock.tickerDetails?.year_low ||
            stock.tickerDetails?.low ||
            null;
        const high52WeekText = (high52Week != null && high52Week > 0) ? (() => {
            const parts = high52Week.toFixed(2).split('.');
            return `$${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${parts[1]}`;
        })() : 'N/A';
        const low52WeekText = (low52Week != null && low52Week > 0) ? (() => {
            const parts = low52Week.toFixed(2).split('.');
            return `$${parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${parts[1]}`;
        })() : 'N/A';
        const price = stock.day?.c || stock.price || 0;
        
        const activeInterval = (typeof getCacheItem === 'function' ? getCacheItem('data-interval') : null) || '1D';
        const intervalLower = activeInterval.toLowerCase();
        let volume;
        if (intervalLower === '1d') {
            volume = stock.cumulative_volume || 0;
        } else if (intervalLower === '5d' || intervalLower === '1m') {
            volume = stock.volume || 0;
        } else {
            volume = stock.cumulative_volume || 0;
        }
        const companyLine = isDerivative && stock.tickerDetails?.underlyingDetails && stock.tickerDetails.underlyingDetails.name
            ? `Company: ${stock.tickerDetails.underlyingDetails.name}`
            : '';
        let sipLabels = '';
        let sipValues = '';
        const chartTypeValue = this.getDataSource();
        const isShortInterestChart = ['sip', 'sip-sec', 'dividend', 'dividend-sec'].includes(chartTypeValue);
        const isDividendChart = chartTypeValue === 'dividend' || chartTypeValue === 'dividend-sec';
        let additionalLabels = '';
        let additionalValues = '';
        if (['top-dollar-vol', 'top-dollar-vol-sec'].includes(chartTypeValue)) {
            const volForDollar = (intervalLower === '5d' || intervalLower === '1m') ? (stock.volume || 0) : (stock.cumulative_volume || 0);
            const dollarVol = (stock.cumulative_dollar_volume || stock.dollarVolume)
                ? (stock.cumulative_dollar_volume || stock.dollarVolume)
                : (price * volForDollar);
            additionalLabels += `Dollar Vol.:\n`;
            additionalValues += `$${this.formatLargeNumber(dollarVol)}\n`;
        }
        if (['top-vol', 'top-vol-sec'].includes(chartTypeValue)) {
            const displayVol = (intervalLower === '5d' || intervalLower === '1m') ? (stock.volume || 0) : (stock.cumulative_volume || 0);
            additionalLabels += `Volume:\n`;
            additionalValues += `${this.formatLargeNumber(displayVol)}\n`;
        }
        if (isShortInterestChart) {
            if (isDividendChart) {
                const yieldPct = stock.trail_1y_div_yield_pct || 0;
                const divAmount = stock.trail_1y_div;
                sipLabels = `Dividend Yield:\n Dividend Amount:\n`;
                sipValues =
                    `${yieldPct.toFixed(2)}%\n` +
                    `$${divAmount.toFixed(2)}\n`;
            } else {
                sipLabels = `Short Interest Percent:\n Settlement date:\n`;
                sipValues =
                    `${stock.short_interest_pct || 'N/A'}%\n` +
                    `${stock.settlement_date || 'N/A'}\n`;
            }
            popup.setAttribute('height', '1');
        }
        const stockDate = document.createElement('a-text');
        stockDate.classList.add('stock-company-date')
        stockDate.setAttribute('value', this.getDateInFormatAsOf(stock.timestamp));
        stockDate.setAttribute('position', isShortInterestChart ? '0.55 0.85 0.001' : '0.55 0.8 0.001');
        stockDate.setAttribute('align', 'center');
        stockDate.setAttribute('color', textColor);
        stockDate.setAttribute('scale', '0.35 0.35 0.35');
        stockDate.setAttribute('width', 4.5);
        stockDate.setAttribute('shader', 'msdf');
        stockDate.setAttribute('font', 'roboto');
        stockDate.setAttribute('negate', 'true');
        stockDate.setAttribute('alphaTest', '0.5');
        let companyLogoUrl = null;
        if (window.CompanyIconAPIManager && stock.ticker) {
            try {
                let apiManager = window.CompanyIconAPIManager.instance;
                if (!apiManager) {
                    apiManager = await window.CompanyIconAPIManager.create();
                }
                companyLogoUrl = await apiManager.loadIcon(stock.ticker);
            } catch (e) {
                console.warn('[stock-bar] Failed to load company icon for showFullPopup:', e);
            }
        }

        const logo = companyLogoUrl ? document.createElement('a-image') : null;
        if (logo) {
            logo.classList.add('stock-company-logo');
            logo.setAttribute('src', companyLogoUrl);
            logo.setAttribute('width', 0.08);
            logo.setAttribute('height', 0.08);
            logo.setAttribute('transparent', true);
            logo.setAttribute('material', 'alphaTest: 0.1');
            logo.setAttribute('position', isShortInterestChart ? '0.38 0.75 0.001' : '0.38 0.65 0.001');
        }

        const companyname = document.createElement('a-text');
        companyname.classList.add('stock-company-name')
        let cName = stock.tickerDetails?.name || stock.tickerSummary?.name || stock.ticker || 'UNKNOWN';
        if (cName.length > 10) {
            cName = cName.substring(0, 10) + '...';
        }
        companyname.setAttribute('value', cName);
        const nameXPos = logo ? 0.48 : 0.43;
        companyname.setAttribute('position', isShortInterestChart ? `${nameXPos} 0.75 0.001` : `${nameXPos} 0.65 0.001`);
        companyname.setAttribute('anchor', 'left');
        companyname.setAttribute('color', textColor);
        companyname.setAttribute('scale', '0.4 0.4 0.4');
        companyname.setAttribute('width', 3.5);
        companyname.setAttribute('shader', 'msdf');
        companyname.setAttribute('font', 'roboto');
        companyname.setAttribute('negate', 'true');
        companyname.setAttribute('alphaTest', '0.5');
        const labels = document.createElement('a-text');
        labels.setAttribute('value',
            `Ticker:\n` +
            `Exchange:\n` +
            `Change:\n` +
            `Price:\n` +
            `Volume:\n` +
            additionalLabels +
            sipLabels +
            `Market Cap:\n` +
            `52-Wk High:\n` +
            `52-Wk Low:`
        );
        labels.setAttribute('position', isShortInterestChart ? '0.52 0.35 0.001' : '0.52 0.3 0.001');
        labels.setAttribute('align', 'right');
        labels.setAttribute('color', labelColor);
        labels.setAttribute('opacity', labelOpacity);
        labels.setAttribute('scale', '0.4 0.4 0.4');
        labels.setAttribute('width', '3.5');
        labels.setAttribute('shader', 'msdf');
        labels.setAttribute('font', 'roboto');
        labels.setAttribute('negate', 'true');
        labels.setAttribute('alphaTest', '0.5');
        const values = document.createElement('a-text');
        values.setAttribute('value',
            `${stock.ticker || 'UNKNOWN'}\n` +
            `${stock.tickerDetails?.primary_exchange || stock.tickerSummary?.primary_exchange || 'Unknown Exchange'}\n` +
            `${(stock.todaysChangePerc || 0).toFixed(1)}%\n` +
            `$${this.formatPriceWithCommas(price)}\n` +
            `${this.formatNumberWithCommas(volume)}\n` +
            additionalValues +
            sipValues +
            `${formatMarketCap(marketCap)}\n` +
            `${high52WeekText}\n` +
            `${low52WeekText}`
        );
        values.setAttribute('position', isShortInterestChart ? '0.58 0.35 0.001' : '0.58 0.3 0.001');
        values.setAttribute('align', 'left');
        values.setAttribute('color', textColor);
        values.setAttribute('scale', '0.4 0.4 0.4');
        values.setAttribute('width', '3.5');
        values.setAttribute('shader', 'msdf');
        values.setAttribute('font', 'roboto');
        values.setAttribute('negate', 'true');
        values.setAttribute('alphaTest', '0.5');
        popup.appendChild(stockDate);
        if (logo) popup.appendChild(logo);
        popup.appendChild(companyname);
        popup.appendChild(labels);
        popup.appendChild(values);
        if (!range52Week && stock.ticker && window.RightPanelProxyAPIManager) {
            (async () => {
                try {
                    let apiManager = window.RightPanelProxyAPIManager.instance || null;
                    if (!apiManager) {
                        try {
                            apiManager = await window.RightPanelProxyAPIManager.create();
                        } catch (createErr) {
                            console.error(`[stock-bar] Failed to create RightPanelProxyAPIManager:`, createErr);
                        }
                    }
                    if (apiManager && apiManager.isInitialized) {
                        const cachedPerformance = apiManager.getCachedData('performance', stock.ticker);
                        if (cachedPerformance && cachedPerformance.range52Week) {
                            const updatedStock = { ...stock, range52Week: cachedPerformance.range52Week };
                            this.updateFullPopup(updatedStock, popup);
                        } else {
                            apiManager.fetchStockPerformance(stock.ticker).then((performanceData) => {
                                if (performanceData && performanceData.range52Week) {
                                    const updatedStock = { ...stock, range52Week: performanceData.range52Week };
                                    this.updateFullPopup(updatedStock, popup);
                                } else {
                                    console.warn(`⚠️ Performance data fetched but no range52Week for ${stock.ticker} in showFullPopup (non-attached)`, performanceData);
                                }
                            }).catch((err) => {
                                console.error('❌ Could not fetch performance data in showFullPopup (non-attached):', err);
                            });
                        }
                    } else {
                        console.warn('⚠️ RightPanelProxyAPIManager not initialized in showFullPopup (non-attached)', {
                            hasManager: !!window.RightPanelProxyAPIManager,
                            hasInstance: !!apiManager,
                            isInitialized: apiManager?.isInitialized,
                            apiManagerType: typeof apiManager
                        });
                    }
                } catch (e) {
                    console.error('❌ Could not fetch performance data from RightPanelProxyAPIManager in showFullPopup (non-attached):', e);
                }
            })();
        } else if (!range52Week) {
            console.warn(`[stock-bar] No range52Week and cannot load in showFullPopup (non-attached):`, {
                hasTicker: !!stock.ticker,
                hasRightPanelProxyAPIManager: !!window.RightPanelProxyAPIManager,
                ticker: stock.ticker
            });
        }
        popup.setAttribute('scale', '0.4 0.4 0.4');
        popup.setAttribute('rotation', '0 45 0');
        const worldPos = new AFRAME.THREE.Vector3();
        this.el.object3D.getWorldPosition(worldPos);
        const cameraEl = document.querySelector('[camera]');
        const cameraPos = new AFRAME.THREE.Vector3();
        if (cameraEl) cameraEl.object3D.getWorldPosition(cameraPos);
        else cameraPos.set(0, 1.6, 0);
        const dir = new AFRAME.THREE.Vector3().subVectors(cameraPos, worldPos).normalize();
        const push = 0.5;
        const sceneWrapper = document.querySelector('#scene-wrapper');
        let minZPos = -0.5;
        if (sceneWrapper && sceneWrapper.object3D && sceneWrapper.object3D.position) {
            minZPos += sceneWrapper.object3D.position.z || 0;
        }
        const posX = worldPos.x + dir.x * push + 0.05;
        const posY = worldPos.y + dir.y * push + 0.05;
        const posZ = Math.min(worldPos.z + dir.z * push * 3, minZPos);
        this.el.sceneEl.appendChild(popup);
        popup.setAttribute('position', `${posX} ${posY} ${posZ}`);
        popup.setAttribute('rotation', '0 0 0');
        if (popup.object3D && typeof THREE !== 'undefined') {
            popup.object3D.position.set(posX, posY, posZ);
            popup.object3D.rotation.set(0, 0, 0);
        }
        setTimeout(() => {
            popup.setAttribute('position', `${posX} ${posY} ${posZ}`);
            popup.setAttribute('rotation', '0 0 0');
            if (popup.object3D) {
                popup.object3D.position.set(posX, posY, posZ);
                popup.object3D.rotation.set(0, 0, 0);
            }
        }, 0);
        this.fullPopup = popup;
    },
    openStockChart: function (stock) {
        const rightPanel = document.getElementById('stock-wrapper');
        const leftPanel = document.getElementById('large-left-panel');
        let leftContent = null;
        if (leftPanel) {
            leftContent = document.getElementById('large-left-panel-content');
            if (leftContent) {
                leftContent.replaceChildren();
            }
        }
        if (!rightPanel) {
            console.error("Right panel wrapper '#stock-wrapper' not found");
            return;
        }
        rightPanel.setAttribute('visible', 'true');
        const noSelectedStockMessage = document.querySelector('#no-selected-stock-message');
        if (noSelectedStockMessage) {
            noSelectedStockMessage.setAttribute('visible', 'false');
        }
        let stockChart = rightPanel.querySelector('#stock-chart');
        if (!stockChart) {
            stockChart = document.createElement('a-entity');
            stockChart.setAttribute('id', 'stock-chart');
            stockChart.setAttribute('position', '-0.55 -0.41 0.5');
            stockChart.setAttribute('scale', '1 1 1');
            rightPanel.appendChild(stockChart);
        }
        const currentPosition = stockChart.getAttribute('position');
        const currentScale = stockChart.getAttribute('scale');
        let currentDataInterval
        let currentShowEventsStatus = false
        const existingUniversal = stockChart.getAttribute('tradingview-universal-chart');
        const existingMountain = stockChart.getAttribute('tradingview-mountain-chart');
        const existingLine = stockChart.getAttribute('tradingview-line-chart');
        const existingCandlestick = stockChart.getAttribute('tradingview-candlestick-chart');
        if (existingUniversal) {
            if (existingUniversal.width != null && stockChart.dataset.chartWidth == null) {
                stockChart.dataset.chartWidth = existingUniversal.width;
            }
            if (existingUniversal.height != null && stockChart.dataset.chartHeight == null) {
                stockChart.dataset.chartHeight = existingUniversal.height;
            }
            if (existingUniversal.dataInterval) {
                currentDataInterval = existingUniversal.dataInterval
            }
            if (existingUniversal.showEvents) {
                currentShowEventsStatus = existingUniversal.showEvents
            }
        }
        const universalType = existingUniversal && existingUniversal.type ? existingUniversal.type : (stockChart.hasAttribute('tradingview-universal-chart') ? (stockChart.getAttribute('tradingview-universal-chart') || {}).type : null);
        const hadCandlestick = universalType === 'candlestick' || !!existingCandlestick || stockChart.hasAttribute('tradingview-candlestick-chart');
        const hadLine = universalType === 'line' || !!existingLine || stockChart.hasAttribute('tradingview-line-chart');
        const persistedType = (stockChart.dataset && stockChart.dataset.chartType) || (typeof getCacheItem === 'function' ? getCacheItem('chart-type') : null);
        const activeType = (persistedType === 'candlestick' || persistedType === 'line' || persistedType === 'mountain')
            ? persistedType
            : (hadCandlestick ? 'candlestick' : (hadLine ? 'line' : 'mountain'));
        const removeConflictingCharts = () => {
            if (stockChart.hasAttribute('tradingview-mountain-chart')) stockChart.removeAttribute('tradingview-mountain-chart');
            if (stockChart.hasAttribute('tradingview-line-chart')) stockChart.removeAttribute('tradingview-line-chart');
            if (stockChart.hasAttribute('tradingview-candlestick-chart')) stockChart.removeAttribute('tradingview-candlestick-chart');
            if (stockChart.hasAttribute('stock-candlestick-chart')) stockChart.removeAttribute('stock-candlestick-chart');
        };
        removeConflictingCharts();
        const dataInterval = currentDataInterval || '1d';
        const is1Day = dataInterval.toLowerCase() === '1d';
        const averageVolumeBar = document.querySelector('#right-average-volume')
        if (averageVolumeBar) {
            averageVolumeBar.setAttribute('visible', is1Day);
        }

        if (rightPanel) {
            if (activeType === 'candlestick') {
                const candleAttrs = {
                    stockData: JSON.stringify(stock),
                    dataInterval: dataInterval,
                    type: 'candlestick',
                    showEvents: currentShowEventsStatus,
                };
                stockChart.setAttribute('tradingview-universal-chart', candleAttrs);
            } else if (activeType === 'line') {
                const lineAttrs = {
                    stockData: JSON.stringify(stock),
                    dataInterval: dataInterval,
                    type: 'line',
                    showEvents: currentShowEventsStatus,
                };
                stockChart.setAttribute('tradingview-universal-chart', lineAttrs);
            } else {
                const areaAttrs = {
                    stockData: JSON.stringify(stock),
                    dataInterval: dataInterval,
                    type: 'mountain',
                    showEvents: currentShowEventsStatus,
                };
                stockChart.setAttribute('tradingview-universal-chart', areaAttrs);
            }
            if (!stockChart.dataset) stockChart.dataset = {};
            stockChart.dataset.chartType = activeType;
            if (typeof setCacheItem === 'function') {
                try { setCacheItem('chart-type', activeType, 1440); } catch (e) { }
                try { setCacheItem('last-opened-stock', stock, 60); } catch (e) { }
            }
            let newSecondarySeriesType = 'volume';
            const dataSource = this.getDataSource();
            if (dataSource === 'sip' || dataSource === 'sip-sec') newSecondarySeriesType = 'sip';
            if (dataSource === 'dividend' || dataSource === 'dividend-sec') newSecondarySeriesType = 'dividend';
            const currentAttrs = stockChart.getAttribute('tradingview-universal-chart') || {};
            stockChart.setAttribute('tradingview-universal-chart', {
                ...currentAttrs,
                secondarySeriesType: newSecondarySeriesType
            });
            let exchange = stock.tickerDetails?.primary_exchange || stock.tickerSummary?.primary_exchange || 'Unknown Exchange';
            if (exchange === "New York Stock Exchange") {
                exchange = "NYSE";
            }
            const formattedTicker = `${exchange}:${stock.ticker || 'UNKNOWN'}`;
            addTickerNewsToLeftPanel(formattedTicker);
            if (currentPosition) stockChart.setAttribute('position', currentPosition);
            if (currentScale) stockChart.setAttribute('scale', currentScale);
        } else {
            console.error("large-right-panel-content not found");
            this.el.appendChild(stockChart);
        }
    },
    resolveStockLogoUrl(stock) {
        const ticker = stock.ticker || '';
        const polygonLogo = stock.tickerDetails?.branding?.logo_url;
        if (polygonLogo) return polygonLogo;
        try {
            const apiManager = window.RightPanelProxyAPIManager?.instance;
            if (apiManager?.isInitialized && ticker) {
                const cached = apiManager.getCachedData('profile', ticker);
                if (cached?.logo) return cached.logo;
            }
        } catch (e) { }
        if (ticker && window.CompanyIconAPIManager) {
            const instance = new window.CompanyIconAPIManager();
            return instance.getIconUrl(ticker);
        }
        if (!ticker) return '#company-logo-temp';
        return `https://images.financialmodelingprep.com/symbol/${ticker.toUpperCase()}.png`;
    },
    getDateInFormatAsOf(originalDataString) {
        if (!originalDataString) return ''
        let isETTimeZone = true;
        const rawSettings = localStorage.getItem('mainSettings');
        if (rawSettings) {
            try {
                const parsed = JSON.parse(rawSettings);
                if (parsed?.value?.isETTimeZone === false) {
                    isETTimeZone = false;
                }
            } catch (e) {
                console.error("Failed to parse settings", e);
            }
        }
        const cleanIso = originalDataString.trim().replace(/\s[A-Z]{3,4}$/, '').replace(' ', 'T');
        let date;
        if (isETTimeZone) {
            date = new Date(cleanIso);
        } else {
            const tempDate = new Date(cleanIso);
            const etOffsetDate = new Date(tempDate.toLocaleString('en-US', { timeZone: 'America/New_York' }));
            const diff = tempDate - etOffsetDate;
            date = new Date(tempDate.getTime() + diff);
        }
        const options = {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        };
        if (!isETTimeZone) {
            options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
        const formatter = new Intl.DateTimeFormat('en-US', options);
        return isNaN(date.getTime()) ? '' : `As of ${formatter.format(date)}`;
    },
    remove: function () {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mousemove', this.onWindowMouseMove);
            window.removeEventListener('mouseup', this.onWindowMouseUp);
            window.removeEventListener('touchstart', this.onWindowTouchStart);
            window.removeEventListener('touchmove', this.onWindowTouchMove);
            window.removeEventListener('touchend', this.onWindowTouchEnd);
            window.removeEventListener('touchcancel', this.onWindowTouchEnd);
        }
    },
    onWindowMouseMove: function (e) {
        this.currentMouse.x = e.clientX;
        this.currentMouse.y = e.clientY;
    },
    onWindowMouseUp: function () {
        if (this.rotationActive) {
            this.stopRotation();
        }
    },

    onWindowTouchStart: function (e) {
        if (e.touches && e.touches.length > 0) {
            this.currentMouse.x = e.touches[0].clientX;
            this.currentMouse.y = e.touches[0].clientY;
        }
    },

    onWindowTouchMove: function (e) {
        if (!this.rotationActive) return;
        if (e.cancelable) e.preventDefault();
        this.currentMouse.x = e.touches[0].clientX;
        this.currentMouse.y = e.touches[0].clientY;
    },

    onWindowTouchEnd: function () {
        if (this.rotationActive) {
            this.stopRotation();
        }
    },

    startRotation: function (event) {
        if (!event || !event.detail) return

        if (this.rotationActive) return;
        this.el.sceneEl.emit('drag-move-start');
        const wrapper = document.querySelector('#stock-3d-cube-wrapper');
        if (!wrapper) return;
        this.rotationActive = true;
        this.wasJustRotating = false;

        if (event.detail.mouseEvent) {
            this.rotationEventType = 'mouse';
            this.startMouse.x = this.currentMouse.x;
            this.startMouse.y = this.currentMouse.y;
            this.dragStartX = this.currentMouse.x;
            this.dragStartY = this.currentMouse.y;
            this.isRotationLocked = false;
            this.rotationLockAxis = null;
        } else if (event.detail.touchEvent) {
            this.rotationEventType = 'touch';
            this.startMouse.x = event.detail.touchEvent.changedTouches[0].clientX;
            this.startMouse.y = event.detail.touchEvent.changedTouches[0].clientY;
            this.dragStartX = event.detail.touchEvent.changedTouches[0].clientX;
            this.dragStartY = event.detail.touchEvent.changedTouches[0].clientY;
            this.isRotationLocked = false;
            this.rotationLockAxis = null;
        } else {
            this.rotationEventType = 'controller';
            if (!this.raycastEl) {
                this.rotationActive = false;
                return;
            }
            this.rotationController = this.raycastEl;
            this.initialControllerQuaternion.copy(this.rotationController.object3D.quaternion);
            if (!this.lastControllerQuat) this.lastControllerQuat = new THREE.Quaternion();
            this.lastControllerQuat.copy(this.rotationController.object3D.quaternion);
            this.isRotationLocked = false;
            this.rotationLockAxis = null;
        }
        this.initialWrapperQuaternion.copy(wrapper.object3D.quaternion);
    },
    stopRotation: function () {
        if (this.rotationActive) {
            this.el.sceneEl.emit('drag-move-end');
            this.wasJustRotating = true;
            setTimeout(() => { this.wasJustRotating = false; }, 100);
        }
        this.rotationActive = false;
        this.rotationController = null;
        this.isRotationLocked = false;
        this.rotationLockAxis = null;
        const wrapper = document.querySelector('#stock-3d-cube-wrapper');
        if (wrapper && wrapper.object3D) {
            const radRot = wrapper.object3D.rotation
            const radToDeg = (rad) => AFRAME.THREE.MathUtils.radToDeg(rad)
            const rotation = `${radToDeg(radRot.x)} ${radToDeg(radRot.y)} ${radToDeg(radRot.z)}`
            this.el.sceneEl.emit('update-rotation', rotation);
            const cameraRig = document.querySelector('#cameraRig');
            if (cameraRig) {
                cameraRig.emit('update-billboards');
            }
            
            if (window.gtag) gtag('event', `VR_CenterPanel_ChartRotation`);
        }
    },
    tick: function () {
        if (this.isCurrentlyHovered) {
            let shouldHide = this.checkIfChartNotBlocked();

            // If we're in desktop mode (mouse available), check for HTML overlays
            if (!shouldHide && this.currentMouse.x && this.currentMouse.y) {
                const elUnder = document.elementFromPoint(this.currentMouse.x, this.currentMouse.y);
                const canvas = this.el.sceneEl.canvas;
                // If something else is under the mouse and it's not the canvas, 
                // it's likely an HTML overlay. (Note: 3D popups are part of the canvas)
                if (elUnder && canvas && elUnder !== canvas) {
                    shouldHide = true;
                }
            }

            if (shouldHide) {
                this.el.emit('mouseleave');
            }
        }

        if (!this.rotationActive) return;
        const wrapper = document.querySelector('#stock-3d-cube-wrapper');
        if (!wrapper) return;

        if (this.rotationEventType === 'controller') {
            if (!this.rotationController || !this.rotationController.object3D) return;
            const currentControllerQuat = this.rotationController.object3D.quaternion.clone();

            const initialControllerQuatInv = this.initialControllerQuaternion.clone().invert();
            const totalDeltaQuat = currentControllerQuat.clone().multiply(initialControllerQuatInv).invert();
            const totalDeltaEuler = new THREE.Euler().setFromQuaternion(totalDeltaQuat, 'YXZ');

            const diffX = Math.abs(totalDeltaEuler.y);
            const diffY = Math.abs(totalDeltaEuler.x);
            const LOCK_THRESHOLD_RAD = 0.02;

            if (!this.isRotationLocked) {
                if (diffX > LOCK_THRESHOLD_RAD || diffY > LOCK_THRESHOLD_RAD) {
                    this.isRotationLocked = true;
                    this.rotationLockAxis = diffX > diffY ? 'x' : 'y';
                } else {
                    return;
                }
            }

            const lastControllerQuatInv = this.lastControllerQuat.clone().invert();
            const incrementalDeltaQuat = currentControllerQuat.clone().multiply(lastControllerQuatInv).invert();
            const incrementalDeltaEuler = new THREE.Euler().setFromQuaternion(incrementalDeltaQuat, 'YXZ');

            const controllerAmplification = 2.0;
            const deltaX = incrementalDeltaEuler.y * controllerAmplification;
            const deltaY = incrementalDeltaEuler.x * controllerAmplification;

            if (Math.abs(deltaX) > 0.0001 || Math.abs(deltaY) > 0.0001) {
                let quatX = new AFRAME.THREE.Quaternion();
                let quatY = new AFRAME.THREE.Quaternion();

                if (this.rotationLockAxis === 'y') {
                    quatX.setFromAxisAngle(new AFRAME.THREE.Vector3(1, 0, 0), deltaY);
                } else if (this.rotationLockAxis === 'x') {
                    quatY.setFromAxisAngle(new AFRAME.THREE.Vector3(0, 1, 0), deltaX);
                }

                const worldDeltaQuat = quatY.multiply(quatX);

                const currentWorldQuat = new AFRAME.THREE.Quaternion();
                wrapper.object3D.getWorldQuaternion(currentWorldQuat);

                const newWorldQuat = worldDeltaQuat.multiply(currentWorldQuat);

                const parentWorldQuat = new AFRAME.THREE.Quaternion();
                wrapper.object3D.parent.getWorldQuaternion(parentWorldQuat);
                const newLocalQuat = parentWorldQuat.invert().multiply(newWorldQuat);

                wrapper.object3D.quaternion.copy(newLocalQuat);
                this.wasJustRotating = true;
            }

            this.lastControllerQuat.copy(currentControllerQuat);
        } else {
            if (!this.isRotationLocked) {
                const diffX = Math.abs(this.currentMouse.x - this.dragStartX);
                const diffY = Math.abs(this.currentMouse.y - this.dragStartY);
                if (diffX > this.LOCK_THRESHOLD || diffY > this.LOCK_THRESHOLD) {
                    this.isRotationLocked = true;
                    this.rotationLockAxis = diffX > diffY ? 'x' : 'y';
                } else {
                    return;
                }
            }
            const sensitivity = 0.01;
            const deltaX = (this.currentMouse.x - this.startMouse.x) * sensitivity;
            const deltaY = (this.currentMouse.y - this.startMouse.y) * sensitivity;
            if (Math.abs(deltaX) > 0.0001 || Math.abs(deltaY) > 0.0001) {
                let quatX = new AFRAME.THREE.Quaternion();
                let quatY = new AFRAME.THREE.Quaternion();
                if (this.rotationLockAxis === 'y') {
                    quatX.setFromAxisAngle(
                        new AFRAME.THREE.Vector3(1, 0, 0),
                        deltaY
                    );
                } else if (this.rotationLockAxis === 'x') {
                    quatY.setFromAxisAngle(
                        new AFRAME.THREE.Vector3(0, 1, 0),
                        deltaX
                    );
                }

                const worldDeltaQuat = quatY.multiply(quatX);

                const currentWorldQuat = new AFRAME.THREE.Quaternion();
                wrapper.object3D.getWorldQuaternion(currentWorldQuat);

                const newWorldQuat = worldDeltaQuat.multiply(currentWorldQuat);

                const parentWorldQuat = new AFRAME.THREE.Quaternion();
                wrapper.object3D.parent.getWorldQuaternion(parentWorldQuat);
                const newLocalQuat = parentWorldQuat.invert().multiply(newWorldQuat);

                wrapper.object3D.quaternion.copy(newLocalQuat);
                this.wasJustRotating = true;
            }
            this.startMouse.x = this.currentMouse.x;
            this.startMouse.y = this.currentMouse.y;
        }
    }
});
